/*=========================================================================================
  File Name: moduleBrokerPackageActions.js
  Description: BrokerPackage Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  // GetItemById({ commit}, itemid ) {
  //   debugger;
  //   const id = parseInt(itemid, 10);
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get("/API/CustomarProperty/GetCustmoerPropertyQRDetailsById?Id=" + id)
  //       .then(response => {
          
  //           commit("SET_QrCode", response.data.Data)
  //           resolve(response)
  //         })
  //         .catch((error) => { reject(error) })
  //     });
  // },
  GetItemById({ commit }, itemid ) {
    debugger;
    const id = parseInt(itemid, 10);
    
    return new Promise((resolve, reject) => {
      
      axios.get("/API/CustomarProperty/GetCustmoerPropertyQRDetailsById?Id=" + id)
        .then((response) => {
          debugger;
          commit('SET_QrCode', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

};
